import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, List, ListItemButton, SxProps, Theme, Typography } from '@mui/material';
import { Link } from 'components/common/Link';
import { StringHelper } from 'helpers/StringHelper';
import useMenuSlugParser from 'hooks/useMenuSlugParser';
import { useToggleAndCloseOnPathChanged } from 'hooks/useToggleAndCloseOnPathChanged';
import { ReactNode } from 'react';
import fonts from 'styles/theme/fonts';

export type ExpandableMenuListProps = {
    title: string;
    sx?: SxProps<Theme>;
    slug: string;
    level: number;
    children?: ReactNode;
    wrapperBoxSx?: SxProps<Theme>;
    listItemButtonSx?: SxProps<Theme>;
    collapseSx?: SxProps<Theme>;
};

export function ExpandableMenuList(props: ExpandableMenuListProps) {
    const {
        title,
        children,
        sx,
        slug,
        level,
        collapseSx,
        wrapperBoxSx,
        listItemButtonSx,
    } = props;
    const [open, toggle] = useToggleAndCloseOnPathChanged();

    const realSlug = StringHelper.uriToSlug(slug);
    const { parseSlug } = useMenuSlugParser();

    return (
        <List sx={sx} component="div">
            <Box
                display="flex"
                sx={{
                    textTransform: 'capitalize',
                    ...wrapperBoxSx,
                }}
                data-testid={`menu-item-${realSlug}`}
            >
                {level === 0 ? (
                    <ListItemButton
                        onClick={toggle}
                        sx={{
                            cursor: 'pointer',
                            padding: 'unset',
                            display: 'contents',
                            ...listItemButtonSx,
                        }}
                    >
                        <Typography
                            sx={{ fontFamily: fonts.notoSans }}
                            dangerouslySetInnerHTML={{ __html: title.toLowerCase() }}
                        />
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                ) : (
                    <>
                        <Link href={parseSlug(slug)}>
                            <Typography
                                sx={{ fontFamily: fonts.notoSans }}
                                dangerouslySetInnerHTML={{ __html: title.toLowerCase() }}
                            />
                        </Link>
                        <ListItemButton
                            onClick={toggle}
                            sx={{
                                cursor: 'pointer',
                                padding: 'unset',
                                display: 'contents',
                                ...listItemButtonSx,
                            }}
                        >
                            {open ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </>
                ) }
            </Box>
            <Collapse
                in={open}
                timeout="auto"
                unmountOnExit
                sx={collapseSx}
            >
                {children}
            </Collapse>
        </List>
    );
}
